import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import TableCustom from '../../../../components/table/tableCustom';
import { ButtonPrimary } from '../../../../components/button/ButtonCustoms';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import ContentHeading from '../../../../components/layout/content/ContentHeading';
import InputTextField from '../../../../components/input/inputTextField';
import { SearchOutlined } from '@mui/icons-material';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import { alertActive, swalError, swalSuccess } from '../../../../components/alert/swal';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import { dateTimeToView } from '../../../../utils/date.utils';
import { routeName } from '../../../../routes/routeName';
import { Typography } from '@mui/material';
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
import { OnlineCourseApi } from '../../../../api/cms-online-course/online_course.api';
import StateComponents from '../../../../components/state-component/StateComponents';
import { debouncedApiCall } from '../../../../utils/app.utils';
import moment from 'moment';

export default function OnlineCourseDiploma() {
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const [data, setData] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState<any>('')
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };

    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const headCells = [
        {
            id: "#",
            width: '100px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: 'ลำดับ'
        },
        {
            id: "leave_type_name",
            width: '500px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ชื่อวุฒิบัตร"),
        },

        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("วันที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const {
            id_online_course_diploma,
            online_course_diploma,
            status,
            modifier_name,
            modified_date } =
            objData;

        const objRenderData = {
            key: id_online_course_diploma,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: online_course_diploma,
                },

                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modifier_name
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableEdit
                            enableDelete
                            onViewClick={() => {
                                navigate(routeName.cms.OnlineCourseDiplomaDetail.replace(':id', id_online_course_diploma) + '?view=true');
                            }}

                            onEditClick={() => {
                                navigate(routeName.cms.OnlineCourseDiplomaDetail.replace(':id', id_online_course_diploma));
                            }}
                            onDeleteClick={() => {
                                alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                    handleDelete(id_online_course_diploma)
                                })
                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };
    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };
            if (startDate) condition = { ...condition, start_date: moment(startDate).format("YYYY-MM-DD") }
            if (endDate) condition = { ...condition, end_date: moment(endDate).format("YYYY-MM-DD") }
            const res = await OnlineCourseApi.listDiploma(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, search, startDate, endDate]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    const handleDelete = async (id: any) => {
        await OnlineCourseApi.deleteDiploma(id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ลบเรียบร้อย'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }
    return (
        <div>
            <NavigateListCustom
                navigateData={[
                    {
                        name: "จัดการข้อมูลคอร์สออนไลน์",
                        key: "1",
                        pathName: routeName.cms.MeetingCalendar,
                    },
                    {
                        name: "จัดการวุฒิบัตร",
                        key: "2",
                        pathName: routeName.cms.MeetingCaledarCreate,
                    },

                ]}
            />
            <section className="my-4">
                <Typography variant="h3">จัดการวุฒิบัตร</Typography>
            </section>

            {/* <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหา")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setSearch(e.target.value)
                        }}
                        value={search || ''}
                    />
                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหา")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setSearch(e.target.value)
                        }}
                        value={search || ''}
                    />
                </article>

                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-9 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    <ButtonPrimary
                        onClick={() => {
                            navigate(routeName.cms.OnlineCourseDiplomaCreate);

                        }}
                        mode="add"
                        buttonName={t("เพิ่มวุฒิบัตร")}
                    />
                </article>
            </div> */}
            <StateComponents
                otherProps={{ spacing: 2 }}
                sxContainer={{marginTop:"10px"}}
                typeProps={[
                    {
                        seq: 1,
                        type: "TEXT_FIELD",
                        gridProps: {
                            xs: 12,
                            md: 4
                        },
                        fieldProps: {
                            placeholder: "ค้นหา",
                            onChange: (e) => debouncedApiCall({ setItem: setSearch, searchItem: e.target.value })
                        }
                    },
                    {
                        seq: 2,
                        type: "DATE_RANGE",
                        gridProps: {
                            xs: 12,
                            md: 3
                        },
                        fieldProps: {
                            onchange: handleChangeDateRange,
                            value: date_range || [],
                            onClear: handleClearDateRange,
                            allowClear: true,
                            placeholder: "ช่วงวันที่"
                        }
                    },
                    {
                        type: "COMPONENT",
                        seq: 3,
                        fieldProps: {
                            element: <></>
                        },
                        gridProps: {
                            xs: 12,
                            md: 3
                        }
                    },
                    {
                        seq: 4,
                        type: "BUTTON",
                        gridProps: {
                            xs: 6,
                            md: 2
                        },
                        fieldProps: {
                            justifyContent: "flex-end",
                            buttonData: [
                                {
                                    seq: 1,
                                    key: "ADD2",
                                    label: "เพิ่มวุฒิบัตร",
                                    buttonProps: {
                                        onClick: () => {
                                            navigate(routeName.cms.OnlineCourseDiplomaCreate);
                                        },
                                    },
                                    type: "ADD2"
                                }
                            ]
                        }
                    }
                ]}
            />

            <section className="w-full mt-4">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
        </div>
    )
}
